<template>
    <div class="notice-publication"
         v-bind:class="getStatus()">

        <div v-if="internalValue.publication_state_id == 1">
            <span v-if="getStatus() == 'ended'">Publication terminée <span v-if="internalValue.end_at">le {{ formatDate(internalValue.end_at) }}</span></span>
            <span v-else-if="getStatus() == 'soon'">Publication programmée le {{ formatDate(internalValue.start_at) }}</span>
            <span v-else>Publication programmée <span v-if="internalValue.end_at">jusqu'au {{ formatDate(internalValue.end_at) }}</span></span>
        </div>

        <div v-if="internalValue.publication_state_id != 1">
            <span>Publication inactive</span>
        </div>

        <div>
            <form-publication-state v-model="internalValue.publication_state_id"></form-publication-state>
        </div>
        <div v-if="internalValue.publication_state_id == 1 && has_dates" class="notice-publication-dates">
            <div v-bind:class="{'active': dates_visible}" @click="showDates()" v-click-outside="onClose">
                <i class="icon icon-icon_calendar"></i>
                <div class="form-published-dates">
                  <form-datetime label="Début" v-model="internalValue.start_at" time="00:00:00" :toggleable="true"></form-datetime>
                  <form-datetime label="Fin" v-model="internalValue.end_at"  time="23:59:59" :toggleable="true"></form-datetime>
<!--
                    <form-date label="Date start" v-model="internalValue.start_at" format="yyyy-MM-dd"></form-date>
                    <form-date label="Date end" v-model="internalValue.end_at" format="yyyy-MM-dd" time="23:59:59"></form-date>
                    -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Published',
        props: ['value','label','name','placeholder','labelPublished','labelUnpublished','dates'],
        data: function () {
            return {
                internalValue: '',
                label_published: null,
                label_unpublished: null,
                dates_visible: false,
                has_dates: false
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.label_published = this.labelPublished ? this.labelPublished : 'no label'
            this.label_unpublished = this.labelUnpublished ? this.labelUnpublished : 'no label'
            this.has_dates = this.dates ? this.dates : false
        },
        methods: {
            refresh: function(date){
              console.log("Refreshing.....")
              this.$forceUpdate()
            },
            showDates: function(){
                this.dates_visible = true;
            },
            onClose: function() {
                this.dates_visible = false;
            },
            formatDate: function(value){
                //moment(value).tz('Europe/Zurich').format('DD.MM.YYYY HH:mm');
                return moment(value).format('DD.MM.YYYY HH:mm');
            },
            getStatus: function()
            {

                var start_at = moment(this.internalValue.start_at || null)
                var end_at = moment(this.internalValue.end_at || null)
                var now = moment();

                var status = 'unpublished'

                if( this.internalValue.publication_state_id == 1 )
                {
                    var status = 'published'

                    if( this.internalValue.start_at && start_at >= now ) {
                        status = 'soon'
                    }

                    if(this.internalValue.end_at && end_at <= now){
                        status = 'ended'
                    }
                }

                return status;
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/NoticePublished.vue